<template>
  <div class="">
    <div v-if="editingIssue">
      <edit-issue @cancel-edit="editingIssue = false" @edit-issue="editingIssue = false" :issue="data"> </edit-issue>
    </div>
    <div v-else>
      <div class="flex flex-row justify-end pb-8 pr-4">
        <a v-if="aasmState != 'closed'" @click="edit()" class="cursor-pointer mr-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        </a>

        <a class="cursor-pointer" @click="destroy(issue)">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </a>
      </div>

      <div class="pb-4 flex flex-row justify-between">
        <div class="flex h-1/2">
          <div v-if="!hideName" class="text-xl pr-4"> {{ `${$t('issues.singular_issue_label')} #${issue.id}` }} </div>

          <div v-if="hideName"> 
            <span v-if="aasmState == 'open'" class="px-4 py-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-200 text-green-800"> {{ $t('issues.open_status') }} </span>
            <span v-if="aasmState == 'under_review'" class="px-4 py-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-200 text-blue-800"> {{ $t('issues.under_review_status') }} </span>
            <span v-if="aasmState == 'closed'" class="px-4 py-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-200 text-red-800"> {{ $t('issues.closed_status') }} </span>
          </div>
          <div v-else>
            <span v-if="aasmState == 'open'" class="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-200 text-green-800"> {{ $t('issues.open_status') }} </span>
            <span v-if="aasmState == 'under_review'" class="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-200 text-blue-800"> {{ $t('issues.under_review_status') }} </span>
            <span v-if="aasmState == 'closed'" class="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-200 text-red-800"> {{ $t('issues.closed_status') }} </span>
          </div>
        </div>

        <div class="flex justify-center">
          <button v-if="aasmState == 'closed' || aasmState == 'under_review'" @click="reopen(issue)" class="mx-4 mb-8 btn btn-secondary"> {{ $t('issues.reopen_label') }} </button>
          <button v-if="aasmState == 'open'" @click="placeUnderReview(issue)" class="mx-4 mb-8 btn btn-secondary"> {{ $t('issues.place_under_review_label') }} </button>
          <button v-if="aasmState == 'open' || aasmState == 'under_review'" @click="close(issue)" class="mx-4 mb-8 btn btn-secondary bg-red-600 text-white"> {{ $t('issues.close_issue_label') }} </button>
        </div>
      </div>

      <div class="grid grid-cols-3 gap-4 mb-4">
        
        <div class="flex flex-col">
          <div class="text-md font-bold"> {{ $t('issues.department_label') }} </div>
          <div class="text-sm"> {{ titleize(department) }} </div>
        </div>
        
        <div class="flex flex-col">
          <div class="text-md font-bold"> {{ $t('issues.topic_label') }} </div>
          <div class="text-sm"> {{ titleize(topic) }} </div>
        </div>
        
        <div class="flex flex-col">
          <div class="text-md font-bold"> {{ $t('issues.description_label') }} </div>
          <div class="text-sm original-field"> {{ issue.description }} </div>
          <div class="text-sm translated-field hidden"> {{ issue.description_translated }} </div>
          <!-- <div class="text-sm text-gray-500"> {{ issue.description }} </div> -->
        </div>

        <div class="flex flex-col">
          <div class="text-md font-bold"> {{ $t('issues.priority_label') }} </div>
          <div class="text-sm"> {{ priority }} </div>
        </div>

        <div class="flex flex-col">
          <div class="text-md font-bold"> {{ $t('issues.created_by_label') }} </div>
          <div class="text-sm"> {{ createdBy }} </div>
        </div>

        <div v-if="aasmState == 'closed'" class="flex pb-2">
          <div class="flex flex-col">
            <div class="text-md font-bold"> {{ $t('issues.closed_by_label') }} </div>
            <div class="text-sm"> {{ closedBy }} </div>
          </div>
        </div>
      </div>

      <activity-feed @issue-activity-item-creation="handleIssueActivityItemCreation($event)" :issue="data" :userId="userId" :userName="userName" :isAdmin="isAdmin" :stateChanged="stateChange" :avatarURL="avatarURL"> </activity-feed>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import ActivityFeed from '@components/issues/ActivityFeed'
  import EditIssue from '@components/issues/EditIssue'

  export default {
    name: '',
    components: {
      ActivityFeed,
      EditIssue,
    },
    data () {
      return {
        aasmState: this.data && this.data.aasm_state,
        editingIssue: false,
        stateChange: null,
      }
    },
    created () {
      console.log("THE DATA", this.data)
    },
    computed: {
      topic () {
        return this.data && this.data.topic && this.data.topic.includes('|') ? this.data.topic.split('|')[1] : this.data && this.data.topic ? this.data.topic : ''
      },
      department() {
        return this.data && this.data.topic && this.data.topic.includes('|') ? this.data.topic.split('|')[0] : ''
      },
      priority () {
        return this.data && this.data.priority[0].toUpperCase() + this.data.priority.slice(1)
      },
      issue () {
        return this.data
      },
      createdBy () {
        return `${this.issue.relationships.created_by.first_name} ${this.issue.relationships.created_by.last_name}`
      },
      closedBy () {
        return this.issue.relationships.closed_by ? `${this.issue.relationships.closed_by.first_name} ${this.issue.relationships.closed_by.last_name}` : this.userName
      },
    },
    methods: {
      titleize(st){
        let words = st.replace('_',' ').split(' ')
        let newWords = words.map(word => {
          return word.charAt(0).toUpperCase() + word.slice(1)
        })
        return newWords.join(' ')
      },
      deliverAxiosRequest (issue, action) {
        axios.patch(`/issues/${issue.id}/${action}`, {
          params: {
            issue_id: issue.id
          }
        }, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          }
        })
        .then(response => {
          console.log("The data2", response)
          return response
        }, error => {
          window.Rollbar.error('error changing issue state', { error: error })
          console.log('error when changing state of issue: ', error)
        })
      },
      reopen (issue) {
        this.deliverAxiosRequest(issue, 'reopen')
        this.aasmState = "open"

        this.stateChange = "reopened"
        
        this.emitStateChange(issue, this.aasmState)
      },
      placeUnderReview (issue) {
        this.deliverAxiosRequest(issue, 'place_under_review')
        this.aasmState = "under_review"

        this.stateChange = "under_review"

        this.emitStateChange(issue, this.aasmState)
      },
      close (issue) {
        this.deliverAxiosRequest(issue, 'close')
        this.aasmState = "closed"

        this.stateChange = "closed"

        this.emitStateChange(issue, this.aasmState)
      },
      edit () {
        this.editingIssue = true
      },
      destroy (issue) {
        let result = confirm("Are you sure you want to delete this issue?")
        if (result) {
          axios.delete(`/issues/${issue.id}`, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
          })
          .then(response => {
            console.log("The data", response)

            this.$emit("delete-issue", {
              issue: this.data,
            })

            if (this.hideName) {
              window.location.reload()
            }

            return response
          }, error => {
            console.log('error when deleting issue: ', error)
          })
        }
      },
      emitStateChange (issue, newState) {
        this.$emit("aasm-state-change", {
          issue: issue,
          newState: newState
        })
      },
      handleIssueActivityItemCreation (event) {
        this.$emit("issue-activity-item-creation", {
          issueActivityItem: event.issue_activity_item,
        })
      },
    },
    watch: {
    },
    props: {
      data: {
        type: Object,
        required: false,
      },
      userName: {
        type: String,
        required: false,
      },
      userId: {
        type: Number,
        required: false,
      },
      isAdmin: {
        type: Boolean,
        required: false,
      },
      hideName: {
        type: Boolean,
        required: false,
      },
      avatarURL: {
        type: String,
        required: false,
      }
    },
  }
</script>

<style lang="scss">
</style>
